import ContentBox from '@/components/supplier/list-contacts/content-box';
import ExportContacts from '@/components/supplier/list-contacts/export-contacts';
import GridContacts from '@/components/supplier/list-contacts/grid-contacts';
import GridContactsDesktop from '@/components/supplier/list-contacts/grid-contacts/grid-desktop';
import GridContactsMobile from '@/components/supplier/list-contacts/grid-contacts/grid-mobile';
import ContactDetailsModal from '@/components/supplier/list-contacts/modal/contact-details';

import { getContactsNetwork, getRetrieveContact } from '@/services/api/contactNetwork';
import { appendQueryString, getQueryStringByName } from '@/utils/';

import { mapState } from 'vuex';

export default {
    name: 'ListContacts',
    props: {
        isMobile: [Boolean, Object]
    },
    components: {
        ContentBox,
        ExportContacts,
        GridContacts,
        GridContactsDesktop,
        GridContactsMobile,
        ContactDetailsModal
    },
    data() {
        return {
            contactsGrid: {
                desktopHeader: [
                    { text: 'Nome fantasia', textAlignment: 'left' },
                    { text: 'Tipo de contato', textAlignment: 'left' },
                    { text: 'Adquirido em', textAlignment: 'left' },
                    { text: 'Origem', textAlignment: 'left' },
                    { text: 'Local', textAlignment: 'left' }
                ],
                mobileHeader: [
                    { text: 'Nome fantasia', textAlignment: 'left' },
                    { text: 'Tipo de contato', textAlignment: 'left' }
                ],
                rows: [],
                desktopColumnWidth: '',
                mobileColumnsWidth: '',
                desktopKeys: ['tradingName', 'contactType', 'acquiredAt', 'source', 'state'],
                mobileKeys: ['tradingName', 'contactType']
            },
            notAvaliableMessage: 'Não disponível',
            selectedContact: {},
            modalSelected: 'ContactDetailsModal',
            showModal: false,
            contactsTotal: 0,
            contactsNextPage: null,
            disableInfiniteScroll: false,
            daysAgoQuery: null
        };
    },
    mounted() {
        this.contactsGrid.desktopColumnsWidth = this.getDesktopColumnsWidth();
        this.contactsGrid.mobileColumnsWidth = this.getMobileColumnsWidth();
        this.listContacts();
    },
    methods: {
        async listContacts() {
            try {
                const contactsResponse = await this.getContactsNetwork();
                this.contactsGrid.rows = contactsResponse.data.results;
                this.contactsGrid.rows = this.contactsGrid.rows.map(row => {
                    row.visible = false;
                    return row;
                });
                this.setContactsTotal(contactsResponse.data.count);
                const nextPage = getQueryStringByName(contactsResponse.data.next, 'page');
                this.contactsNextPage = nextPage;
            } catch (error) {
                console.error(error);
                this.contactsGrid.rows = [];
            }
        },
        async getContactsNetwork(queriesStrings = '') {
            return getContactsNetwork(queriesStrings);
        },
        async retrieveContact(contactId) {
            try {
                const contactResponse = await getRetrieveContact(contactId);
                if (contactResponse.data.immobile && contactResponse.data.immobile.particulars) {
                    contactResponse.data.immobile.particulars = contactResponse.data.immobile.particulars.join(', ');
                }
                this.selectedContact = contactResponse.data;
                this.modalSelected = 'ContactDetailsModal';
                this.showModal = true;
            } catch (error) {
                console.error(error);
            }
        },
        setContactsTotal(value) {
            this.contactsTotal = value;
        },
        getDesktopColumnsWidth: function() {
            const width = 100 / this.contactsGrid.desktopHeader.length;
            return `repeat(auto-fit, minmax(${width}%, 1fr))`;
        },
        getMobileColumnsWidth: function() {
            const width = 100 / this.contactsGrid.mobileHeader.length;
            return `repeat(auto-fit, minmax(${width}%, 1fr))`;
        },
        async loadMoreContacts() {
            if (this.hasMoreContacts) {
                this.disableInfiniteScroll = true;
                try {
                    let queriesStrings = appendQueryString('', `page=${this.contactsNextPage}`);
                    queriesStrings = appendQueryString(queriesStrings, this.daysAgoQuery);

                    const contactsResponse = await this.getContactsNetwork(queriesStrings);
                    this.contactsGrid.rows = this.contactsGrid.rows.concat(contactsResponse.data.results);
                    const nextPage = getQueryStringByName(contactsResponse.data.next, 'page');
                    this.contactsNextPage = nextPage;
                } catch (error) {
                    console.error(error);
                }
                this.disableInfiniteScroll = false;
            }
        },
        async updateFilter(daysAgo) {
            try {
                this.daysAgoQuery = daysAgo;
                const queriesStrings = appendQueryString('', daysAgo);
                const contactsResponse = await this.getContactsNetwork(queriesStrings);
                this.contactsGrid.rows = contactsResponse.data.results;
                const nextPage = getQueryStringByName(contactsResponse.data.next, 'page');
                this.contactsNextPage = nextPage;
                this.setContactsTotal(contactsResponse.data.count);
                this.$forceUpdate();
            } catch (error) {
                console.error(error);
            }
        }
    },
    computed: {
        ...mapState('user', ['user']),
        hasMoreContacts() {
            return this.contactsNextPage != null;
        },
        infiniteScrollDistance() {
            return Math.min(50, this.contactsGrid.rows.length) * 60 * 0.7;
        }
    }
};
